module.exports = __webpack_public_path__ + "static/media/url.7670daf8.PNG";